import React from 'react'
import { Badge, Box, makeStyles } from '@material-ui/core'
import { AlertCircle } from 'react-feather'

const useStyles = makeStyles((theme) => ({
  badge: {
    width: 18,
    height: 18,
    color: theme.palette.warning.main,
    marginLeft: 12,
  },
}))

type Props = {
  label: string
  showBadge: boolean
}

export function LabelWithAlertBadge({
  label,
  showBadge,
}: Props): React.ReactElement {
  const classes = useStyles()

  return (
    <Box display="flex" flexDirection="row">
      <Badge
        overlap="rectangular"
        badgeContent={<AlertCircle className={classes.badge} />}
        invisible={!showBadge}
      >
        {label}
      </Badge>
    </Box>
  )
}
